import { graphql, useStaticQuery } from 'gatsby';

export default function allProducts() {
  return useStaticQuery(graphql`
    query GetProducts {
      allNeProduct {
        nodes {
          availableForSale
          box
          bundleAndSave
          vendor
          title
          tags
          descriptionHtml
          description
          sample_pack_buy_url
          product_card_description
          productType
          presets
          modulargrid
          conservation
          images {
            altText
            url
            src_sm
            src_md
            src_lg
            src_xl
          }
          videos {
            alt
            url
          }
          manual_link
          learn_more_links
          id
          handle
          featuresandspecs
          description
          seo {
            title
            description
          }
          quotes {
            name
            quote
          }
          sounds {
            name
            src
          }
          variants {
            nodes {
              id
              title
              availableForSale
              image {
                url
                altText
                src_sm
                src_md
                src_lg
                src_xl
              }
              priceV2 {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `).allNeProduct.nodes;
}
